import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from './api/api.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { DEFAULT_LANGUAGE, ROUTE_PATHS, ALL_PATHS } from '../route-paths';


@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private defaultLanguage: string;
  private languageSubject = new BehaviorSubject<string>(DEFAULT_LANGUAGE);
  currentLanguage$ = this.languageSubject.asObservable();
  public currentUrl: string = '';

  constructor(private translate: TranslateService, public apiService: ApiService, public translateService: TranslateService, public router: Router) {
    this.setDefaultLanguage();
  }

  setDefaultLanguage() {
    const browserLang = this.translate.getBrowserLang();

    const currentUrl = window.location.href;
    if (currentUrl.includes('/en')) {
      this.defaultLanguage = 'en';
    }
    else {
      // Default to Turkish if no language prefix found
      this.defaultLanguage = 'tr';
    }
    this.languageSubject.next(this.defaultLanguage);

    this.translate.setDefaultLang(this.defaultLanguage);
    this.translate.use(this.defaultLanguage);
  }

  getDefaultLanguage(): string {
    return this.defaultLanguage;
  }

  changeLanguage(lang: string) {
    this.languageSubject.next(lang);
    this.apiService.loadTranslation(lang);
    this.translateService.use(lang);
    this.defaultLanguage = lang;

    const currentUrl = this.router.url.split('/');
    // For Turkish URLs, path is at index 1. For English URLs, path is at index 2
    const isCurrentlyEnglish = currentUrl[1] === 'en';
    const currentPath = isCurrentlyEnglish ? currentUrl[2] : currentUrl[1];

    let newPath = '';

    if (currentPath != '' && currentPath != null && currentPath != undefined && lang != undefined && lang != null) {
      const pathKey = ALL_PATHS[currentPath.replace('-', '_')]?.replace('-', '_');
      if (pathKey && ROUTE_PATHS[lang] && ROUTE_PATHS[lang][pathKey]) {
        newPath = ROUTE_PATHS[lang][pathKey];
      }
    }

    if (lang === 'tr') {
      // Turkish routes are at root level
      if (newPath != '') {
        this.router.navigateByUrl(`/${newPath}`);
      } else {
        this.router.navigateByUrl('/');
      }
    } else {
      // English routes have /en prefix
      if (newPath != '') {
        this.router.navigateByUrl(`/en/${newPath}`);
      } else {
        this.router.navigateByUrl('/en');
      }
    }
  }

  // navigateWithLang(path: string) {
  //   let newPath = ROUTE_PATHS[this.defaultLanguage][ALL_PATHS[path.replace('-', '_')].replace('-', '_')];
  //   this.router.navigate([`/${this.defaultLanguage}/${newPath}`]);
  // }


}
